import {createSlice} from '@reduxjs/toolkit';
import {v4 as uuidv4} from 'uuid';
import moment from 'moment';

const initialState = {
  auditID: null,
  latitude: 28.5355,
  longitude: 77.3910,
  searchedDate: null,
  images360Count: null,
  windshieldCount: null,
  regNoCount: null,
  chassisRCCount: null,
  odometerCount: null,
  tyresCount: null,
  auditStatus: null,
  user_userID: null,
  auditDetails: {
    Make: null,
    Model: null,
    Variant: null,
  },
  auditModes: [],
};
const generateRandomNDigitString = n => {
  const uuid = uuidv4 ().replace (/-/g, '');
  const randomString = uuid.substring (0, n);
  return randomString;
};

const imagesSlice = createSlice ({
  name: 'images',
  initialState,
  reducers: {
    setAuditID: (state, action) => {
      state.auditID = action.payload;
    },
    setSearchedDate: (state, action) => {
      state.searchedDate = action.payload;
    },
    set_360_count: (state, action) => {
      state.images360Count = action.payload;
    },
    set_windshield_count: (state, action) => {
      state.windshieldCount = action.payload;
    },
    set_reg_no_count: (state, action) => {
      state.regNoCount = action.payload;
    },
    set_chassis_rc_count: (state, action) => {
      state.chassisRCCount = action.payload;
    },
    set_odometer_count: (state, action) => {
      state.odometerCount = action.payload;
    },
    set_audit_status: (state, action) => {
      state.auditStatus = action.payload;
    },
    set_tyres_count: (state, action) => {
      state.tyresCount = action.payload;
    },
    set_latitude_longitude: (state, action) => {
      state.latitude = action.payload.latitude;
      state.longitude = action.payload.longitude;
    },
    set_audit_details: (state, action) => {
      const {type, value} = action.payload;

      state.auditDetails[type] = value;
    },
    set_audit_modes: (state, action) => {
      state.auditModes = action.payload;
    },
    set_user_ID: (state, action) => {
      console.log('set_user_ID triggered with payload:', action.payload);
      state.user_userID = action.payload;
    },
    set_full_audit_details: (state, action) => {
      const {userId} = action.payload;

      // Bulk update of auditDetails
      state.auditDetails = {
        ...state.auditDetails,
        'User Id': userId,
        'Insurance Company': "Surveyor's AI",
        'Powered By': 'Surveyor AI',
        'Dealer Code': 'AFA764FA00',
        'Inspection Date': moment ().format ('DD-MM-YYYY'),
        'Inspection Time': moment ().format ('HH:mm'),
        'Client Unique Reference No.': generateRandomNDigitString (
          10
        ).toUpperCase (),
        'Year of Manufacturing': moment ().format ('YYYY'),
        'Report Generate Date & Time': moment (new Date ()).format (
          'DD MMM, YYYY hh:mm:ss a'
        ),
      };
    },
  },
});

export const {
  set_360_count,
  set_reg_no_count,
  set_chassis_rc_count,
  setSearchedDate,
  set_odometer_count,
  set_windshield_count,
  setAuditID,
  set_audit_status,
  set_latitude_longitude,
  set_tyres_count,
  set_audit_details,
  set_full_audit_details,
  set_audit_modes,
  set_user_ID
} = imagesSlice.actions;

export default imagesSlice.reducer;
